export const UPDATE_NOTIFICATION = "UPDATE_NOTIFICATION";